import { useCallback } from 'react';
import { parseAsBoolean, parseAsStringEnum, useQueryStates } from 'nuqs';
import {
  CompositeViewConfig,
  DEFAULT_COMPOSITE_VIEW_CONFIG,
  EhCompositeMode,
} from 'types';

const CV_QUERY_KEYS = {
  cv_kl: parseAsBoolean.withDefault(
    DEFAULT_COMPOSITE_VIEW_CONFIG.showKeyLevels,
  ),
  cv_mode: parseAsStringEnum<EhCompositeMode>(
    Object.values(EhCompositeMode),
  ).withDefault(DEFAULT_COMPOSITE_VIEW_CONFIG.compositeMode),
};

export function useCompositeViewConfig(): [
  CompositeViewConfig,
  (patch: Partial<CompositeViewConfig>) => void,
] {
  const [params, setParams] = useQueryStates(CV_QUERY_KEYS);

  const config: CompositeViewConfig = {
    showKeyLevels: params.cv_kl,
    compositeMode: params.cv_mode,
  };

  const updateConfig = useCallback(
    (patch: Partial<CompositeViewConfig>) => {
      const urlPatch: Partial<typeof params> = {};
      if (patch.showKeyLevels != null) {
        urlPatch.cv_kl = patch.showKeyLevels;
      }
      if (patch.compositeMode != null) {
        urlPatch.cv_mode = patch.compositeMode;
      }
      void setParams(urlPatch);
    },
    [setParams],
  );

  return [config, updateConfig];
}
